import forge from 'node-forge'

// 生成 RSA 密钥
// -----BEGIN RSA PUBLIC KEY----- YES
// -----BEGIN PUBLIC KEY-----     NO
export async function generateRSAKeyPair() {
  const keypair = forge.pki.rsa.generateKeyPair({ bits: 1024 }) // 生成1024位的RSA密钥对
  // 将公钥导出为 PKCS#1 格式 (RSA 公钥)
  const publicKey = forge.pki.publicKeyToRSAPublicKeyPem(keypair.publicKey)
  // 将私钥导出为 PEM 格式
  const privateKey = forge.pki.privateKeyToPem(keypair.privateKey)
  return { publicKey, privateKey }
}

// 使用私钥解密
export function rsaDecrypt(privateKeyPem, encryptedText) {
  const privateKey = forge.pki.privateKeyFromPem(privateKeyPem)
  // base64 解码
  const base64Data = forge.util.decode64(encryptedText)

  const chunks = []
  const chunkSize = 128
  for (let i = 0; i < base64Data.length; i += chunkSize) {
    const chunk = base64Data.slice(i, i + chunkSize)
    const decryptedText = privateKey.decrypt(chunk)
    chunks.push(decryptedText)
  }
  const jsonStr = chunks.join('')

  return jsonStr
}
